import { Routes } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { RegisterComponent } from './register.component';
import {RegisterConfirmationComponent} from './register-confirmation.component';

export const registerRoute: Routes = [{
  path: 'register',
  component: RegisterComponent,
  data: {
    authorities: [],
    pageTitle: 'register.title'
  },
  canActivate: [UserRouteAccessService]
}, {
    path: 'register-confirmation',
    component: RegisterConfirmationComponent,
    data: {
        authorities: [],
        pageTitle: 'register.confirmation.title'
    },
    canActivate: [UserRouteAccessService]
}];



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/register/register.route.ts